import { render, staticRenderFns } from "./AppLeftSidebar.vue?vue&type=template&id=abadd6b4"
import script from "./AppLeftSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppLeftSidebar.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../work/modules/node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiIcon: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@3/components/ui/UiIcon.vue').default,UiSelect: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@3/components/ui/UiSelect.vue').default})
